
































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Account } from '@/@types/Account';

@Component
export default class ParticipationConditionCard extends Vue {
  @Prop(Object) public account!: Account | undefined;
  @Prop(Boolean) public accountLoading!: boolean;
  private weeklyFullOperationTime: number = 40;
  private remoteMainWork: string = 'リモート';
  private onsiteMainWork: string = 'オンサイト';
  private mainWork: string = 'リモート、オンサイト';

  private getWorkStyle(): string {
    if (this.account?.remoteFlag && !this.account?.onsiteFlag) {
      return this.remoteMainWork;
    } else if (this.account?.onsiteFlag && !this.account?.remoteFlag) {
      return this.onsiteMainWork;
    } else {
      return this.mainWork;
    }
  }
}
